import { combineReducers } from 'redux'
import { firebaseReducer } from "react-redux-firebase";

const rootReducer = combineReducers({
  firebaseReducer
});

export default rootReducer;